/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 30.08.17.
 */

import React from "react";
import PropTypes from "prop-types";
import DateTimePicker from "../../../../components/Bootstrap/DateTimePicker";

class DateWidget extends React.Component {
    static propTypes = {
        schema: PropTypes.object.isRequired,
        id: PropTypes.string.isRequired,
        value: PropTypes.any,
        disabled: PropTypes.bool,
        readonly: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func,
        placeholder: PropTypes.string
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    fixValue(value) {
        if (value == null || value === "") return value;
        // TODO: ajv validator does not support timezone and milliseconds in "time" format, removing this
        let idx = value.indexOf("+");
        if (idx === -1) idx = value.indexOf("Z");
        if (idx >= 0) value = value.substring(0, idx);
        idx = value.indexOf(".");
        if (idx >= 0) value = value.substring(0, idx);
        return value;
    }

    render() {
        // moment.locale('en');
        let inputProps = {
            id: this.props.id
        };
        if (this.props.disabled) inputProps.disabled = "disabled";
        if (this.props.readonly) inputProps.readonly = "readonly";
        return (
            <DateTimePicker
                mode={this.props.schema.format}
                value={this.props.value}
                inputProps={inputProps}
                onChange={(newValue) => {
                    this.props.onChange((newValue == null ? undefined : this.fixValue(newValue)));
                }}
                onBlur={this.props.onBlur && (newValue => {
                    this.props.onBlur((newValue == null ? undefined : this.fixValue(newValue)));
                })}
                placeholder={this.props.placeholder}
            />
        );
    }
}

export default DateWidget;
